module.exports = __webpack_public_path__ + "static/puto-bigas-e5e21ba4a8a1b6562980b82df9f3f916.jpg";